/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ user: NonNullable<unknown> }} Automation_Action_Assign_TaskInputs */

const en_automation_action_assign_task = /** @type {(inputs: Automation_Action_Assign_TaskInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Assign to ${i?.user}`)
};

const pt_br2_automation_action_assign_task = /** @type {(inputs: Automation_Action_Assign_TaskInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Atribuir a ${i?.user}`)
};

/**
* | output |
* | --- |
* | "Assign to {user}" |
*
* @param {Automation_Action_Assign_TaskInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const automation_action_assign_task = /** @type {((inputs: Automation_Action_Assign_TaskInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Automation_Action_Assign_TaskInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_automation_action_assign_task(inputs)
	return pt_br2_automation_action_assign_task(inputs)
});